export enum PrinterType {
  InvoicePrinter,
  ThermalPrinter,
  LabelPrinter
}

export enum PrintingType {
  Invoice,
  ChangeTable,
  Report,
  OrderInfo,
  Customize,
  Label
}



// WEBPACK FOOTER //
// ./src/app/services/printertype.enum.ts